/**
 * AI Analysis Filters
 *
 * Filters related to AI-generated analysis and recommendations
 * To add a new AI filter, simply add a new object to this array
 */

import { Filter } from '../../types/filters';

export const aiFilters: Filter[] = [
  // ===== INVESTMENT STRATEGY =====
  {
    id: 'ai_strategy',
    name: 'Investment Strategy',
    description: 'Filter deals by investment strategy',
    category: 'ai',
    type: 'multiselect',
    minTier: 'STARTER',
    premiumFeature: false,
    popularityRank: 19,
    dataPath: 'teaser.strategies', // Array of strategies on each deal (backend always populates this, falling back to [teaser.strategy] for legacy records)
    version: '2.0',
    enabled: true,
    defaultValue: [], // Empty = show all strategies (no filter)
    config: {
      options: [
        { value: 'btl', label: 'BTL (Buy to Let)', icon: '', disabled: false },
        { value: 'flip', label: 'FLIP (Fix and Flip)', icon: '', disabled: false },
        { value: 'hmo', label: 'HMO (House in Multiple Occupation)', icon: '', disabled: false },
        { value: 'brrr', label: 'BRRR (Buy, Refurb, Rent, Refinance)', icon: '', disabled: false },
        { value: 'bmv', label: 'BMV (Below Market Value)', icon: '', disabled: false },
        { value: 'rent_to_rent', label: 'Rent-to-Rent', icon: '', disabled: false },
        { value: 'r2sa', label: 'Rent-to-SA', icon: '', disabled: false },
      ],
      defaultSelected: [],
      multiSelect: true
    }
  }
];
